import React, { useMemo, useState } from 'react';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import { Checkbox, FormControlLabel } from '@mui/material';

export const StepRequisitosClientes = ({ fullFormData, handleChangeFullFormData, REQUISITOS, allowedWrite }) => {

    const handleCheck = (e) => {
        const { name, value } = e.target;
        handleChangeFullFormData(name, parseInt(value));

        if ((name === 'remito_FK' || name === 'remito_NH') && value !== 1) {
            const remito = name === 'remito_FK' ? 'iDTipoRemitoFK' : 'iDTipoRemitoNH';

            handleChangeFullFormData(remito, null);
        }
    };

    const handleCheckRemito = (e) => {
        const { name, value } = e.target;

        handleChangeFullFormData(name, parseInt(value));
    };

    const initialColumns = [
        {
            flex: 0.3,
            field: 'fielName',
            headerName: '',
            renderCell: ({ row }) => <p>{row.descripcion}</p>
        },
        {
            flex: 0.2,
            field: 'si',
            headerName: 'Si',
            renderCell: ({ row, index }) => <FormControlLabel control={
                <Checkbox
                    checked={fullFormData[row.name] === 1}
                    size="small"
                    id={index}
                    disabled={!allowedWrite}
                    name={row.name}
                    value={1}
                    onChange={handleCheck}
                />
            } />
        },
        {
            flex: 0.2,
            field: 'no',
            headerName: 'No',
            renderCell: ({ row, index }) => <FormControlLabel control={
                <Checkbox
                    checked={fullFormData[row.name] === 0}
                    size="small"
                    id={index}
                    disabled={!allowedWrite}
                    name={row.name}
                    value={0}
                    onChange={handleCheck}
                />
            } />
        },
        {
            flex: 0.2,
            field: 'opcional',
            headerName: 'Opcional',
            renderCell: ({ row, index }) => <FormControlLabel control={
                <Checkbox
                    checked={fullFormData[row.name] === 2}
                    size="small"
                    id={index}
                    disabled={!allowedWrite}
                    name={row.name}
                    value={2}
                    onChange={handleCheck}

                />
            } />
        },
        {
            flex: 0.2,
            field: 'digital',
            headerName: 'Digital',
            renderCell: ({ row, index }) => (row.name === 'remito_FK' || row.name === 'remito_NH')
                && <FormControlLabel control={
                    <Checkbox
                        checked={
                            row.name === 'remito_FK' ?
                                fullFormData.iDTipoRemitoFK === 1 :
                                fullFormData.iDTipoRemitoNH === 1
                        }
                        size="small"
                        id={index}
                        name={
                            row.name === 'remito_FK' ?
                                'iDTipoRemitoFK' :
                                'iDTipoRemitoNH'
                        }
                        value={1}
                        disabled={!allowedWrite || (
                            row.name === 'remito_FK' ?
                                fullFormData.remito_FK !== 1 :
                                fullFormData.remito_NH !== 1)
                        }
                        onChange={handleCheckRemito}

                    />
                } />
        },
        {
            flex: 0.2,
            field: 'original',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Original',
            renderCell: ({ row, index }) => (row.name === 'remito_FK' || row.name === 'remito_NH')
                && <FormControlLabel control={
                    <Checkbox
                        checked={
                            row.name === 'remito_FK' ?
                                fullFormData.iDTipoRemitoFK === 2 :
                                fullFormData.iDTipoRemitoNH === 2
                        }
                        size="small"
                        id={index}
                        name={
                            row.name === 'remito_FK' ?
                                'iDTipoRemitoFK' :
                                'iDTipoRemitoNH'
                        }
                        value={2}
                        disabled={!allowedWrite || (
                            row.name === 'remito_FK' ?
                                fullFormData.remito_FK !== 1 :
                                fullFormData.remito_NH !== 1)
                        }
                        onChange={handleCheckRemito}

                    />
                } />
        }
    ];

    const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [fullFormData]);

    return (
        <div>
            <DataGridGenerico
                columns={columns}
                rows={REQUISITOS}
                toolbar={false}
                pageSize={25}
            />
        </div>
    )
}